
import React, { Fragment, useState } from 'react'
import {AppButton,AppRow,AppGridBar,AppForm,AppGridTabs, AppTable} from 'qcc'
import { Row, Icon ,Col} from 'antd';
import api, {PosAppProjectOutput, HttpResult} from 'api';
import {PosApiInputBar} from '../components/PosApiInputBar'
import {PosApiInputContent} from '../components/PosApiInputContent'

let inputConfig = {
    example : "" ,
    formdata:{mac:''} ,
    labelWidth:100 ,
    items:
    [
        {lable:'mac',field:'mac',placeholder:'string类型，设备的MAC地址'},
    ]
};

let outputExample = [
    
] as HttpResult

export const Statement = () =>{

    const[outputResult,setOutputResult]  = useState(null as HttpResult)
    const[outputView,setOutputView]  = useState(0)

    const execApi = async () =>{
        let res = await api.public.statement.getStatementFromFtp({date:"20200801"});
        setOutputResult(res);
    }
    
    let refPosApiInputContent = React.createRef<PosApiInputContent>();
    return (<div className='app-demo-content'>
            <h1>T+1手续费</h1>    
            <div>
                1、T+1手续费手动同步<br/>
                2、地址：/api/public/statement/getStatementFromFtp <br/>
                3、get方式传值<br/>
            </div>

            <div className='app-pos-api-input'>
                <PosApiInputBar  fn={execApi}/>
                <div className='app-pos-api-input-line'/>
                <PosApiInputContent ref={refPosApiInputContent} config={inputConfig} />
            </div>

            <div className='app-pos-api-input'>
                <AppGridBar>
                    <AppGridBar.Left>
                        <AppGridTabs defaultTabIndex={outputView} 
                        onChange={(tabIndex)=>{setOutputView(tabIndex)}} 
                        tabs={['JSON']}/>
                    </AppGridBar.Left>
                </AppGridBar>
                <div className='app-pos-api-input-line'/>
                <Row className='app-pos-api-input-content'>
                    <Col span={8} className='app-pos-api-input-example'>
                        <div>示例：</div>
                        <pre>{JSON.stringify(outputExample, null, 4)}</pre>
                    </Col>
                </Row>

            </div>

            
            
    </div>)
}


// WEBPACK FOOTER //
// ./src/posapi/app/Statement.tsx